import type { IInstrumentId, IInstrumentLabel, Question } from './types'
import type { PdfTemplate } from '../visit/visit.interface'


export interface IEntry {
  id: string
  visitId: string
  instrumentId: string
  instrumentVersion: number
  derivedValues?: Record<string, unknown>
  responses?: Record<string, string>
  authentication?: IEntryAuthentication
  updatedAt: null | Date
  visitTime?: Date
  completionDateTime?: Date
}

export interface IEntryAuthentication {
  id: string
  entryId: string
  patientMRN: string
  patientName: string
  patientSignature: string
  signedOn: Date
  witnessName?: string
  witnessId?: string
  witnessSignature?: string
  witnessedOn: null | Date
}

export interface IInstrumentMetadata {
  instrumentId: IInstrumentId
  label: IInstrumentLabel
  latestVersion: number
  allVersions: number[]
  completedVersions: number[]
}

export interface IInstrument {
  id: IInstrumentId
  type: string
  version: number
  label: IInstrumentLabel
  pdfTemplates: PdfTemplate[]
  questions?: Record<string, Question>
}

export interface IUsePatientInstruments {
  instrumentMetadata: IInstrumentMetadata[]
  isError: boolean
  isLoading: boolean
  getInstruments: () => void
}

export interface IUseInstruments {
  instruments: IInstrument[]
  isError: boolean
  isLoading: boolean
  getInstruments: () => void
}

export interface IUsePatientInstrumentResponses {
  editResponses: (entryId: string, responses: Record<string, string>) => void
  entries: IEntry[]
  isError: boolean
  isLoading: boolean
  getEntries: (patientId: string, instrumentId: string) => void
}

export interface IUseEntries {
  entries: IEntry[]
  isError: boolean
  isLoading: boolean
  getEntries: (patientId: string, instrumentId: string) => void
}

export interface IUseInstrument {
  instrument: IInstrument
  getInstrument: (instrumentId: IInstrumentId, version: number) => void
}

export enum QuestionTypeId {
  Binary = 'binary',
  Checkbox = 'checkbox',
  Date = 'date',
  Radio = 'radio',
  Scale = 'scale',
  Text = 'text',
  VisualAnalogScale = 'visual_analog_scale',
  NumericWithUnits = 'numeric-with-units',
}

export enum InstrumentTypeId {
  Form = 'form',
  Consent = 'consent',
}
